module.exports = __webpack_public_path__ + "img/erweima_kf_rz.6284ac40.png";